import { HStack, Text } from '@chakra-ui/react';
import React from 'react';

import { colors } from '../colors';
import { Icon } from './icons';

type IconTagProps = {
  icon: string;
  text: string;
};
export const IconTag = ({ icon, text }: IconTagProps) => {
  return (
    <HStack
      borderRadius="32px"
      spacing="16px"
      padding="8px 24px"
      border={`1px solid ${colors.gray[200]}`}
    >
      <Icon type="solid" icon={icon} />
      <Text fontWeight="bold">{text}</Text>
    </HStack>
  );
};

type IconElementTagProps = {
  icon: string;
  children: React.ReactNode;
};
export const IconElementTag = ({ icon, children }: IconElementTagProps) => {
  return (
    <HStack
      borderRadius="32px"
      spacing="16px"
      padding="8px 24px"
      border={`1px solid ${colors.gray[200]}`}
    >
      <Icon type="solid" icon={icon} />
      {children}
    </HStack>
  );
};
